export const PLEASE_WAIT = 'Please wait...';
export const NETWORK_UNAVAILABLE = 'Network unavailable. Please check your network settings.';